import { z } from "zod/v4";

/**
 * A support user asked a camera to produce a test signal.
 *
 * `signalPath` records which delivery leg was exercised — the two cover
 * different parts of the path and a reader chasing "which heartbeat stopped
 * arriving" needs to know which one was fired. `topic` and `publishedAt` are
 * the publish receipt, so an audit entry can be tied to the device log line
 * and to any signal that followed.
 *
 * Note what this does **not** claim: the entry records that a command was
 * accepted for delivery, not that a signal was produced.
 */
export const TestSignalTriggeredActivityMetadata = z.object({
  signalPath: z.enum(["camera", "va"]),
  topic: z.string(),
  publishedAt: z.iso.datetime(),
});
export type TestSignalTriggeredActivityMetadata = z.infer<typeof TestSignalTriggeredActivityMetadata>;
